import "./SeeMoreCoversButton.css";
import { Flex } from "@simplybusiness/mobius";
import type { SeeMoreCoversProps } from "./types";
import classNames from "classnames/dedupe";
import { CoversButton } from "./CoversButton";

const SeeMoreCoversButton = ({ ref, ...props }: SeeMoreCoversProps) => {
  const { onClick, className, desktop = true, label, showButton } = props;
  const containerClasses = classNames("mobius", "see_more_covers-container");
  const buttonClasses = classNames(
    "mobius",
    "see_more_covers-button",
    className,
  );

  if (!showButton) {
    return null;
  }

  if (desktop) {
    return (
      <CoversButton onClick={onClick} className={className} label={label} />
    );
  }

  return (
    <Flex
      ref={ref}
      className={containerClasses}
      justifyContent="center"
      alignItems="center"
    >
      <CoversButton onClick={onClick} className={buttonClasses} label={label} />
    </Flex>
  );
};
SeeMoreCoversButton.displayName = "SeeMoreCoversButton";
export { SeeMoreCoversButton };
